import * as React from "react"
import { Button } from "@design/ui/button"
import { Kbd } from "@design/ui/kbd"

export interface FileUploadAreaWiring {
  fileUploadAreaTitle?: string
  fileUploadAreaText?: string
  fileUploadAreaShowButton?: boolean
  button: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart?: boolean
  buttonLabel?: string
  buttonShowKbd?: boolean
  kbd: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
  buttonShowIconEnd?: boolean
}

export const FileUploadAreaContext = React.createContext<FileUploadAreaWiring | null>(null)

export function useWiring(): FileUploadAreaWiring {
  const wiring = React.useContext(FileUploadAreaContext)
  if (wiring === null) {
    throw new Error("FileUploadAreaScreen: render inside <FileUploadAreaContext.Provider>")
  }
  return wiring
}
